import { useRelatedProducts } from '../hooks/useRelatedProducts';

type RelatedProductsContainerProps = { children: React.ReactNode };

const RelatedProductsContainer = ({ children }: RelatedProductsContainerProps) => {
	const { blockClass } = useRelatedProducts();

	const renderClass = () => blockClass && `vtex-shelf-1-x-relatedProducts--${blockClass}`;

	return <div className={`vtex-shelf-1-x-relatedProducts ${renderClass()}`}>{children}</div>;
};

export default RelatedProductsContainer;
